<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-smart-tag-configuration">
    <el-tabs v-model="activeTab" tab-position="left" @tab-click="handleTabClick" :before-leave="beforeLeave">
      <el-tab-pane name="targetSubTitle" :disabled="true" label="Alerts:" class="sub-title">
      </el-tab-pane>
      <!-- <el-tab-pane name="newConfig" label="New config">
       Test
      </el-tab-pane> -->
      <el-tab-pane name="smartTagNotifications" label="Usage">
        <wy-smart-tag-configuration-targets ref="configurationUsages" :controller="controller"/>
      </el-tab-pane>
    </el-tabs>
    <wy-dialog 
      ref="updateDialog"
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Save"
      discardButtonLabel="Discard"
    />

  </div>
</template>

<script>
import wySmartTagConfigurationUsages from '../configuration/wy-smart-tag-configuration-usage-tab';
import WyDialog from '../../widgets/wy-dialog.vue'
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'wy-analytics-configuration',
  modalTitle: 'Configuration',
  modelContentStyle: 'width: calc(100vw - 100px) !important; max-width: unset !important; max-width: unset !important; height: calc(100vh - 100px);',

  components: { 
    'wy-smart-tag-configuration-targets': wySmartTagConfigurationUsages,
    'wy-dialog': WyDialog,
  },

  props: ['appVue'],
  
  data() {
    return {
      controller: this,
      activeTab: 'smartTagNotifications',
      configurationData: {},
      hasError: false,
    };
  },

  computed: {
    ...mapGetters(['companyProfileSettings']),

    hasNoSavedChanges() {
      return this.$refs.configurationUsages && this.$refs.configurationUsages.hasNoSavedChanges
    }
  },

  methods: {
    ...mapActions(['fetchCompanyProfileSettings']),
    beforeLeave(newTab, oldTab) {
      if(this.$refs.configurationUsages && this.$refs.configurationUsages.hasNoSavedChanges) {
        this.handleUnSavedChanges(newTab, oldTab, null)
        return false
      }
    },

    handleUnSavedChanges(newTab, oldTab, handleAppModalClose) {
      if(this.$refs.configurationUsages && this.$refs.configurationUsages.hasNoSavedChanges) {
        if(oldTab == 'smartTagNotifications') {
          this.$refs.configurationUsages.handleSaveUnchanges(newTab, handleAppModalClose)
        }
        return false
      }
    },

    handleTabClick() {
      
    },
  }
};
</script>

<style lang="scss">
.wy-smart-tag-configuration {
  height: 100%;

  .dialogue-content-container {
    line-height: 25px;
    margin-left: 41px;
  }

  .el-tabs, .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
    height: 100%;    
  }
  .el-tabs__nav-scroll {
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #CAD2DA !important;
      border-radius: 50px !important; 
    } 
  }
  #pane-topicKPIs.el-tab-pane, #pane-overallKPIs.el-tab-pane   {
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6px !important;
      height: 6px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #CAD2DA !important;
      border-radius: 50px !important; 
    } 
  }
  .el-tabs__header {
    padding: 0px;
  }
  .el-tabs__header.is-left {
    width: 230px !important;
  }

  .el-tabs__nav.is-left {
    #tab-targetSubTitle, #tab-databaseSubTitle, #tab-alertsSubTitle, #tab-transcriptsSubTitle, #tab-configurationsTitle {
      background-color: #FFF !important;
      color: var(--site-font-secondary-color) !important;
      // border-right: 2px solid #E4E7ED;
      background-color: transparent !important;
      font-weight: 600;
    }
    #tab-targetSubTitle:hover {
      color: var(--site-font-secondary-color) !important;
    }
    #tab-targetContactReasons.is-disabled:hover {
      color: #C0C4CC !important;
    }
  }


  .el-tabs.el-tabs--left > .el-tabs__content {
    height: 100%;
    display: flex;
    box-sizing: border-box;
    padding: 20px;
    overflow-y: auto;
    .el-tab-pane {
      width: 100%;
      height: 100%;
    }
    &::-webkit-scrollbar {
      width: 20px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 160px;
      border: 3px solid transparent;
      border-top: 5px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      background:#F3F6F8;
      border-top: 1px solid #CAD2DA;
    }
    &::-webkit-scrollbar:vertical {
      width: 14px;
    }
    &::-webkit-scrollbar-thumb:vertical {
      border-radius: 160px;
      border: 2px solid transparent;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track:vertical {
      // border-left: 1px solid #CAD2DA;
      border-top: none !important;
    }
  }
  .pane-topicBlacklist {
    min-width: 1145px;
  }
  .el-loading-mask {
  .el-loading-spinner {
    top: 35%;
    background: var(--site-loading-icon);
    background-repeat: no-repeat;
    background-size: 25px;
    background-position: center;  
    .circular {
      display: inline-block;
      width: 90px;
      height: 90px; 
    }
  }
  .el-loading-spinner .path {
    -webkit-animation: loading-dash 2s ease-in-out infinite;
    animation: loading-dash 2s ease-in-out infinite;
    stroke-dasharray: 90,150;
    stroke-dashoffset: 0;
    stroke-width: 2.5 !important;
    stroke: #0C2837 !important;
    stroke-linecap: round;  
    }
  }
  .el-tabs__item:hover{
    // color: #214586;
    color: var(--site-font-primary-color);
  }
  .el-tabs__item.is-active {
    background-color: #E2ECF7;
    color: var(--site-font-primary-color);
    // color: #214586;
  }

  .el-tabs__active-bar {
    background-color: transparent;
    width: 6px !important;
  }

  div#pane-topics {
    height: 100%;
    //min-width: 1252px;
    padding-right: 20px;
  }
  div#pane-topicBlacklist {
    height: 100%;
    // min-width: 1118px;
    width: 1370px;
    // padding-right: 20px;
  }
}
.configuration-failed-message {
  top: 16% !important;
  background-color: #FFF4F4;
  border-color: #EBAFBA;
  color: var(--site-font-secondary-color);
  .el-icon-error {
    height: 15px;
    width: 15px;
    background-repeat: no-repeat;
    background-size: 15px;
    background-image: url('../../../assets/icons/icon_configuration_update_failed.svg') !important;
  }
  .el-icon-error:before {
    content: unset;
  }
  .el-message__content {
    color: var(--site-font-secondary-color);
    font-weight: 700;
  }
}
.configuration-success-message {
  background-color: #D9EEDF;
  border-color: #86D2AE;
  .el-icon-success {
    color: #186731;
  }
  .el-message__content {
    color: var(--site-font-secondary-color);
    font-weight: 700;
  }
  .el-message__closeBtn {
    color: #5C5F62;
  }
}
</style>